import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";
import { attrToBool } from "common/helpers";

var data$7 = {
  close: "Schließen",
  info: "Info",
  warning: "Warnung",
  error: "Fehler",
  offline: "Offline",
};
data$7.close;
data$7.info;
data$7.warning;
data$7.error;
data$7.offline;

var data$6 = {
  close: "close",
  info: "info",
  warning: "warning",
  error: "error",
  offline: "offline",
  feature: "feature",
};
data$6.close;
data$6.info;
data$6.warning;
data$6.error;
data$6.offline;
data$6.feature;

var data$5 = {
  close: "cerrar",
  info: "información",
  warning: "advertencia",
  error: "error",
  offline: "sin conexión",
};
data$5.close;
data$5.info;
data$5.warning;
data$5.error;
data$5.offline;

var data$4 = {
  close: "fermer",
  info: "information",
  warning: "avertissement",
  error: "erreur",
  offline: "hors ligne",
};
data$4.close;
data$4.info;
data$4.warning;
data$4.error;
data$4.offline;

var data$3 = {
  close: "閉じる",
  info: "情報",
  warning: "警告",
  error: "エラー",
  offline: "オフライン",
};
data$3.close;
data$3.info;
data$3.warning;
data$3.error;
data$3.offline;

var data$2 = {
  close: "닫기",
  info: "정보",
  warning: "경고",
  error: "오류",
  offline: "오프라인",
};
data$2.close;
data$2.info;
data$2.warning;
data$2.error;
data$2.offline;

var data$1 = {
  close: "fechar",
  info: "informações",
  warning: "aviso",
  error: "erro",
  offline: "offline",
};
data$1.close;
data$1.info;
data$1.warning;
data$1.error;
data$1.offline;

var data = {
  close: "关闭",
  info: "信息",
  warning: "警告",
  error: "错误",
  offline: "离线",
};
data.close;
data.info;
data.warning;
data.error;
data.offline;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$7,
  en: data$6,
  esMX: data$5,
  fr: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const icons = {
  info: "info",
  warning: "warning",
  error: "error",
  offline: "offline",
  preview: "preview",
  feature: "magicwand",
};
class alert extends LightningElement {
  @api variant = "info";
  @api dismissible = null;
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;

  get isDismissible() {
    return attrToBool(this.dismissible);
  }

  get iconAssistiveText() {
    // eslint-disable-next-line
    return this.labels[this.variant];
  }

  get iconSymbol() {
    return icons[this.variant];
  }

  get className() {
    return `alert alert--${this.variant} ${
      (this.isDismissible && "dismissible") || ""
    }`;
  }

  handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }
}

export default alert;
